import React from "react";
import { Props } from "./type";
import styles from "./styles.scss";
import classNames from "classnames";

function ToggleButton(props: Props) {
  return (
    <div
      onClick={() => props.setIsActive(!props.isActive)}
      className={styles.toggleButton}
    >
      <div className={styles.button}>
        <div
          className={classNames(styles.dot, {
            [styles.right]: props.isActive,
            [styles.left]: !props.isActive,
            [styles.active]: props.isActive,
          })}
        />
      </div>
    </div>
  );
}

export { ToggleButton };
